import { render, staticRenderFns } from "./Plant.vue?vue&type=template&id=0c6775ec&scoped=true&"
import script from "./Plant.vue?vue&type=script&lang=js&"
export * from "./Plant.vue?vue&type=script&lang=js&"
import style0 from "./Plant.vue?vue&type=style&index=0&id=0c6775ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6775ec",
  null
  
)

export default component.exports